(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.Visibility = factory());
}(this, (function () { 'use strict';

    var _hidden = 'hidden';
    var _visibilityChange = 'visibilitychange';
    var HAS_DOCUMENT = typeof document !== 'undefined';
    if (HAS_DOCUMENT) {
        if (document.hidden !== undefined) {
            _hidden = 'hidden';
            _visibilityChange = 'visibilitychange';
        }
        else if (document.mozHidden !== undefined) {
            _hidden = 'mozHidden';
            _visibilityChange = 'mozvisibilitychange';
        }
        else if (document.msHidden !== undefined) {
            _hidden = 'msHidden';
            _visibilityChange = 'msvisibilitychange';
        }
        else if (document.webkitHidden !== undefined) {
            _hidden = 'webkitHidden';
            _visibilityChange = 'webkitvisibilitychange';
        }
    }
    var HIDDEN = _hidden;
    var VISIBILITY_CHANGE = _visibilityChange;

    var states = ['visible', 'hidden'];
    function getVisibilityState() {
        if (!HAS_DOCUMENT)
            return 'hidden';
        return document[HIDDEN] ? 'hidden' : 'visible';
    }
    var VisibilityManager = /** @class */ (function () {
        function VisibilityManager() {
            var _this = this;
            this._state = getVisibilityState();
            this._stateListeners = [];
            this._typedCallbacks = {
                visible: [],
                hidden: [],
            };
            HAS_DOCUMENT && document.addEventListener(VISIBILITY_CHANGE, function (e) {
                _this._setState(getVisibilityState(), e);
            }, false);
        }
        Object.defineProperty(VisibilityManager.prototype, "state", {
            get: function () {
                return this._state;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VisibilityManager.prototype, "isVisible", {
            get: function () {
                return this._state === 'visible';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VisibilityManager.prototype, "isHidden", {
            get: function () {
                return this._state === 'hidden';
            },
            enumerable: true,
            configurable: true
        });
        VisibilityManager.prototype._setState = function (state, event) {
            if (this._state !== state) {
                this._state = state;
                this._triggerStateListeners(state, event);
                this._triggerTypedCallback(state, event);
            }
        };
        VisibilityManager.prototype._triggerStateListeners = function (state, event) {
            var listeners = this._stateListeners.slice();
            listeners.forEach(function (listener) {
                listener(state, event);
            });
        };
        VisibilityManager.prototype._triggerTypedCallback = function (state, event) {
            var callbacks = this._typedCallbacks[state].slice();
            callbacks.forEach(function (callback) {
                callback(event);
            });
        };
        VisibilityManager.prototype.change = function (listener) {
            var _this = this;
            this._stateListeners.push(listener);
            var remover = function () {
                _this.remove(listener, 'change');
            };
            return remover;
        };
        VisibilityManager.prototype.visible = function (callback) {
            var _this = this;
            this._typedCallbacks.visible.push(callback);
            var remover = function () {
                _this.remove(callback, 'visible');
            };
            return remover;
        };
        VisibilityManager.prototype.hidden = function (callback) {
            var _this = this;
            this._typedCallbacks.hidden.push(callback);
            var remover = function () {
                _this.remove(callback, 'hidden');
            };
            return remover;
        };
        VisibilityManager.prototype.remove = function (listenerOrCallback, targetState) {
            if (!targetState || targetState === 'change') {
                var index = this._stateListeners.indexOf((listenerOrCallback));
                if (index !== -1) {
                    this._stateListeners.splice(index, 1);
                    return;
                }
            }
            for (var _i = 0, states_1 = states; _i < states_1.length; _i++) {
                var state = states_1[_i];
                if (targetState && state !== targetState)
                    continue;
                var targets = this._typedCallbacks[state];
                var index = targets.indexOf((listenerOrCallback));
                if (index !== -1) {
                    targets.splice(index, 1);
                    return;
                }
            }
        };
        return VisibilityManager;
    }());
    var visibilityManager = new VisibilityManager();

    return visibilityManager;

})));
